"use strict";
exports.__esModule = true;
exports.ERROR_MODAL = void 0;
exports.ERROR_MODAL = {
    HEADER: 'Something went wrong',
    PARAGRAPH_1: "We ran into a technical issue when trying to process your request. Please try again in a few moments.",
    CTA_TEXT: 'Close'
};
